import { Component } from '@angular/core';
import { AppData } from '../../../app-data';
import { EmployeeRoom } from '../../../model/api/administration/employee-room';
import { Param } from '../../../model/common/param';
import { GenericTableList } from '../../generic/generic.table.list';

@Component({
    selector: 'employee-room-list',
    templateUrl: '../../generic/generic.table.list.html'
})
export class EmployeeRoomList extends GenericTableList<EmployeeRoom, number> {

    private listName: string = 'EMPLOYEEROOMS';

    constructor() {
        super('id', 'asc', '');
        this.columns = AppData.ColumnDefinitions[this.listName];
    }

    public refresh(filters: Array<Param>) {
        this.columns = AppData.ColumnDefinitions[this.listName];
        super.refresh(filters);
    }
}
